// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".YL2NqyMrqIPBagyIScWJ{position:absolute;right:10px;top:10px;padding:0;z-index:10000;background-color:#fff;min-width:auto;border-radius:50%;height:24px;width:24px;box-shadow:none;display:flex;justify-content:center;align-items:center}@media(min-width: 768px){.YL2NqyMrqIPBagyIScWJ{right:-18px;top:-18px;height:36px;width:36px;box-shadow:0px 4px 4px rgba(0,0,0,.25)}}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"closeBtn": "YL2NqyMrqIPBagyIScWJ"
};
export default ___CSS_LOADER_EXPORT___;
